export default __webpack_public_path__ + "static/media/pricelist-4.732cac1c.svg";